export function overwriteImage({
  imageOverwriteFeature,
  path,
  defaultSkuId,
  image,
}) {
  return imageOverwriteFeature && path.includes(imageOverwriteFeature.nValue)
    ? `//johnlewis.scene7.com/is/image/JohnLewis/${defaultSkuId}${imageOverwriteFeature.postfix}?`
    : image;
}

export function overwriteSelectedSwatch({
  imageOverwriteFeature,
  path,
  selectedSwatch,
}) {
  if (imageOverwriteFeature && path.includes(imageOverwriteFeature.nValue)) {
    // eslint-disable-next-line no-param-reassign
    selectedSwatch.imageUrl = `//johnlewis.scene7.com/is/image/JohnLewis/${selectedSwatch.skuId}${imageOverwriteFeature.postfix}?`;
  }
  return selectedSwatch;
}
